import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";
import authService from "../../Services/authService";

export const getDepartmentDoctor =createAsyncThunk("getDoc",async({ relativeId, departmentId },{dispatch})=>{
try{
    dispatch(setLoading(true));
    let response;
    if (authService.getIsDoctorLogin() === "false") {
        response = await api.get(`/api/v1/hospital/manage/department/doctor`,{params:{relativeId, departmentId}});
    }
    return response.data
}
catch(error){
      const errorMessage = error.response && error.response.data ? error.response.data.message : "Error Doctor list";
      throw new Error(errorMessage);
}
finally{
    dispatch(setLoading(false));
}
})

export const getDoctorTimeslots = createAsyncThunk( "getDoctorTimeslots", async ({ doctorId, date, duration }, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      let response;

      if (authService.getIsDoctorLogin() === "false") {
        response = await api.get(
          `/api/v1/hospital/manage/doctor/${doctorId}/timeslots`,
          { params: { date, duration } }
        );
      }

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : "Error fetching doctor timeslots";
      throw new Error(errorMessage);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const updateAppointment = createAsyncThunk(
  "updateAppointment",
  async ({ appointmentId, data }, { dispatch }) => {
    try {
      dispatch(setLoading(true));

      // data contains all fields: doctorId, departmentId, startTime, duration, reschedulingReason
      const response = await api.put(
        `/api/v1/hospital/manage/appointment/${appointmentId}/update`,
        data
      );

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : "Error updating appointment";
      throw new Error(errorMessage);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
